<template>
  <div class="slider relative">
    <h6 class="absolute time-spent" v-if="hideTimeSpent" >Time Spent:(min)</h6>
    <div class="progress-container" :style="`width:${`${width}px` || '100%'}`"  style="position:relative;">
      <div :class="userWidth != 100 && userWidth >= 85 ? 'reverse-tool-tip' : ''" :style="`width:${userWidth}%; z-index:${userZIndex}`"  class="userbar1">
        <div class="icon"></div>
        <div class="tooltip-progress">{{myTime}}</div>
        <div class="arrow-progress"></div>
      </div>
      <div :class="averageWidth != 100 && averageWidth >= 85 ? 'reverse-tool-tip' : ''" :style="`width:${averageWidth}%; z-index:${averageZIndex}`"  class="averagebar2">
        <div class="icon"></div>
        <div class="tooltip-progress">{{avgTime}}</div>
        <div class="arrow-progress"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userWidth:0,
      userZIndex:1,
      averageZIndex:2,
      averageWidth:0,
    }
  },
  props:{
    myTime:{
      typeof:Number,
      required:true
    },
    avgTime:{
      typeof:Number,
      required:true
    },
    width:{
      typeof:Number,
      required:false
    },
    hideTimeSpent:{
      typeof:Boolean,
      required:false,
      default: true,
    }
  },
  methods:{
    initSlider(){
      var calc = this.calculatePercentages(this.myTime,this.avgTime);
      
      if(calc.userPercentage > calc.averagePercentage){
        this.userZIndex = 1;
        this.averageZIndex = 2;
      }
      else{
        this.userZIndex = 2;
        this.averageZIndex = 1;
      }

      const changeProgress = (progress) => {
        this.userWidth = progress;
      };

      setTimeout(() => changeProgress(calc.userPercentage), 700);

      const changeProgress2 = (progress) => {
        this.averageWidth = progress;
      };

      setTimeout(() => changeProgress2(calc.averagePercentage), 700);
    },
    calculatePercentages(user,average){
      var returnObject = {
        userPercentage : 0,
        averagePercentage : 0
      }
      if(user>average){
        returnObject.userPercentage = 100;
        returnObject.averagePercentage = average/user*100;
      }
      else{
        returnObject.averagePercentage = 100;
        returnObject.userPercentage = user/average*100;
      }

      return returnObject;
    }
  },
  mounted(){
    this.initSlider();
  },
  
}
</script>



<style scoped lang="scss">
  .progress-container {
  height: 0.8rem;
  width: 32rem;
  border-radius: 0.4rem;

  background: #000;
}

.slider {
  display: flex;
  background: transparent;
  margin-top: 40px;
  margin-bottom: 10px;

}

.progress-container .userbar1 .averagebar2{
  height: 100%;
  width: 0;
  border-radius: 0.4rem;

  //background: #ff4754;

  transition: width 0.4s ease;
}
.userbar1{
  position: absolute;
  left: 0;
  float:left;
  height: 100%;
  width: 0;
  position: relative;
  border-radius: 0.4rem;
  background-color: rgba(var(--vs-primary),100);
  transition: width 0.4s ease;
  &:hover{
    filter: brightness(1.25);
  }
  .icon{
    width: 18px;
    height: 160%;
    display: block;
    background-color: rgba(var(--vs-primary),100);
    border-radius: 50%;
    right: 0;
    top: -3px;
    position: absolute;
    border: 1px solid rgba(var(--vs-primary),100);
    box-shadow: 0px 0px 4px 0px black;

  }
  .arrow-progress{
    border-top: 13px solid rgba(var(--vs-primary),100);
  }
}

.tooltip-progress{
  position: absolute;
  left: 100%;
  bottom: 20px;
  background-color: inherit;
  padding: 2px;
  color: rgb(19, 19, 19);
  border-radius: 2px;
  font-weight: bold;
}

.arrow-progress{
  position: absolute;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  transform: rotate(45deg);
  border-radius: 44px;
  right: -9px;
  top: -16px;
}

.averagebar2{
  position: absolute;
  left: 0;
  float:left;
  height: 100%;
  width: 0;
  border-radius: 0.4rem;
  background: white;
  transition: width 0.4s ease;
  &:hover{
    filter: brightness(0.90);
  }
  .icon{
    width: 18px;
    height: 160%;
    display: block;
    background-color: white;
    border-radius: 50%;
    right: 0;
    top: -3px;
    position: absolute;
    border: 1px solid white;
    box-shadow: 0px 0px 4px 0px black;
  }
  .arrow-progress{
    border-top: 13px solid white;
  }
}

.reverse-tool-tip{
  .icon{
    width: 18px;
    height: 160%;
    display: block;
    background-color: white;
    border-radius: 50%;
    right: 0;
    top: -3px;
    position: absolute;
    border: 1px solid white;
    box-shadow: 0px 0px 4px 0px black;
  }
  .arrow-progress{
    right: 6% !important;
    transform: rotate(-49deg) !important;
  }
  .tooltip-progress{
    left: 84% !important;
  }
}
.time-spent{
  top: -20px;
}

</style>